var datafilter = (function ($) {
	"use strict";
	var $dataFilter,
		init = function () {
			$dataFilter = $('.dataFilter', '#extras');
			if ($dataFilter.length > 0) {
				datafilter.main.init();
			}
		};
	$(document).ready(init);
	return {
		$: $,
		g: function () {
			return $dataFilter;
		}
	};
})(jQuery);

datafilter.main = (function (parent) {
	"use strict";
	var $ = parent.$,
		$form,
		$input,
		$category,
		$alpha,
		$list,
		init = function () {
			$list = parent.g().find('.item');
			jQuery.expr[':'].startsWith = function (a, i, m) {
				//noinspection JSConstructorReturnsPrimitive
				var t = $(a).text().replace(/^\s*/, '').substring(0, 1);
				return (t || "").toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
			};
			jQuery.expr[':'].containsIC = function (a, i, m) {
				var t = $(a).text();
				return (t || "").toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
			};
			initSearch();

			var hash = location.hash.slice(1);
			if (hash.length > 0) {
				$('select.category').val(hash).change();
			}
		},
		initSearch = function () {
			$form = parent.g().find('form');
			$form.on('submit', function(e) {
				e.preventDefault();
			});
			$input = $form.find('input').keyup(function (e) {
				//if (e.which == 13) { // Enter
				var t = this;
				doSearch.call(t);
				//}
			});
			$category = $form.find('select.category').change(doSearch);
			$alpha = $form.find('a').click(doSearch);
		},

		doSearch = function (e) {
			if (e) {
				e.preventDefault();
			}
			var $this = $(this);
			var t = this.tagName;
			if (t === 'SELECT') {
				$alpha.removeClass('selected');
			}
			else if (t === 'INPUT') {
				$alpha.removeClass('selected');
			}
			else {
				// t === a
				if ($this.hasClass('all')) {
					$alpha.removeClass('selected');
					$category.prop('selectedIndex', 0);
				}
				if ($this.hasClass('selected') && !$this.hasClass('all')) {
					$alpha.removeClass('selected');
				}
				else {
					$alpha.removeClass('selected');
					$this.addClass('selected');
				}
			}
			var searchValue = $input.val();
			var categoryValue = $category.val();
			var alphaHref = $alpha.filter('.selected').attr('href');
			var selectedAlpha = (alphaHref) ? alphaHref.replace('#', '').substring(0, 1) : '';
			var $res = $list;
			if (categoryValue) {
				$res = $res.filter('.' + categoryValue);
			}
			var scrollTop = $(window).scrollTop() ;
			location.hash = categoryValue;
			window.scrollTo(0, scrollTop);

			if (selectedAlpha) {
				$res = $res.find('.title:startsWith("' + selectedAlpha + '")').parent();
			}
			if (searchValue) {
				$res = $res.find(':containsIC("' + searchValue + '")').parent();
			}
			$list.removeClass('open');
			result($res);
		},
		result = function ($filtered) {
			if ($filtered) {
				$list.addClass('hide');
				$filtered.removeClass('hide')
			}
			else {
				$list.removeClass('hide')
			}
			$('body').removeClass('initFilter');
		};
	return {
		init: init
	};
})(datafilter);
